import { useState, useEffect } from 'react';
import api from '../api/axios';

const useGoogleDrive = () => {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkStatus();
    // Verifica si viene de callback de Google
    const params = new URLSearchParams(window.location.search);
    if (params.get('google_connected') === 'true') {
      setConnected(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  const checkStatus = async () => {
    try {
      const res = await api.get('/google/status');
      setConnected(res.data.connected);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const connect = async () => {
    try {
      const res = await api.get('/google/auth');
      window.location.href = res.data.url;
    } catch (error) {
      console.error(error);
    }
  };

  const disconnect = async () => {
    try {
      await api.post('/google/disconnect');
      setConnected(false);
    } catch (error) {
      console.error(error);
    }
  };

  return { connected, loading, connect, disconnect, checkStatus };
};

export default useGoogleDrive;
